import styled from "@emotion/styled";
import { Avatar, FlexRow, H4, Link } from "atoms";
import { FollowButton } from "features/follows";
import { useAuth } from "features/auth";
import type { Image } from "features/images";

type PostCardHeaderProps = {
  artistId: string;
  artistName?: string;
  artistIcon?: Image;
  hideFollow?: boolean;
};

function ArtistPostHeading({
  artistId,
  artistName,
  artistIcon,
  hideFollow = false,
}: PostCardHeaderProps) {
  const { user } = useAuth();
  const userIsCurrentArtist = user?.claimedArtistPageIds?.includes(artistId);

  return (
    <ArtistPostHeadingElement>
      <FlexRow alignItems="center" justifyContent="space-between">
        <FlexRow alignItems="center" gap="6px">
          <Link
            to={`/artists/${artistId}`}
            aria-hidden
            tabIndex={-1}
            style={{ display: "inline-flex", alignItems: "center" }}
          >
            <Avatar src={artistIcon?.url300 || artistIcon?.url} size={26} />
          </Link>
          <H4
            size="xxs"
            style={{ margin: 0, display: "inline-flex", alignItems: "center" }}
          >
            <Link
              to={`/artists/${artistId}`}
              style={{ textDecoration: "none" }}
            >
              {artistName}
            </Link>
          </H4>
        </FlexRow>

        {!hideFollow && !userIsCurrentArtist && (
          <FollowButton small entityId={artistId} />
        )}
      </FlexRow>
    </ArtistPostHeadingElement>
  );
}

const ArtistPostHeadingElement = styled.div(({ theme }) => ({
  position: "relative",
  width: "100%",
  ".Tooltip": {
    position: "static",
  },
  "& .TooltipContent": {
    left: 0,
    top: 0,
    bottom: "auto",
    right: 0,
    maxWidth: "none",
    width: "100%",
    "&::before, &::after": {
      content: "none",
    },
  },
}));

export { ArtistPostHeading };
